import { useLazyGetCourseNamesQuery } from '../services/courses';

/**
 * Hook to send a request to get the course names for the selected team courses (array of course ids).
 * @returns {Object} Query result object with data, isLoading, error
 */
export const useGetCourseNames = () => {
  const [fetchCourses, { data, error, isLoading, isFetching }] = useLazyGetCourseNamesQuery();
  return { fetchCourses, courses: data, error, isLoading, isFetching };
};
